<div class="auth-layout">
  <aside class="auth-brand">
    <img *ngIf="logoUrl()" class="auth-brand-logo" [src]="logoUrl()" alt="" />
    <div class="auth-brand-body">
      <h2 *ngIf="headline()" class="auth-headline">
        {{ headline() | translate }}
      </h2>
      <div class="auth-rule"></div>
      <ul class="auth-features" *ngIf="visibleFeatures().length">
        <li *ngFor="let feature of visibleFeatures()">
          <i [class]="feature.icon" aria-hidden="true"></i>
          <span>{{ feature.text | translate }}</span>
        </li>
      </ul>
    </div>
    <div class="auth-footer">
      <span *ngIf="footer()">{{ footer() | translate }}</span>
      <span *ngIf="version()" class="auth-version"> · v{{ version() }}</span>
    </div>
  </aside>
  <main class="auth-main">
    <div class="auth-top-right">
      <ng-content select="[authTopRight]"></ng-content>
    </div>
    <div class="auth-column">
      <img
        *ngIf="logoUrlOnLight()"
        class="auth-logo-on-light"
        [src]="logoUrlOnLight()"
        alt=""
      />
      <img
        *ngIf="logoUrl()"
        class="auth-logo-on-dark"
        [src]="logoUrl()"
        alt=""
      />
      <ng-content></ng-content>
    </div>
  </main>
</div>
